import { observer } from 'mobx-react';
import { getUserSmtp } from 'owa-groups-adaptors';
import { MaxGroupMembersToReturn } from 'owa-groups-shared-actions/lib/loadGroupAction';
import GroupFacepilePersona from 'owa-groups-shared-components/lib/GroupFacepilePersona';
import { GroupInformation } from 'owa-groups-shared-store/lib/schema/GroupInformation';
import * as React from 'react';

const styles = require('./GroupFacepile.scss');

export interface FacepileMemberInfo {
    smtpAddress: string;
    displayName: string;
}

export interface GroupFacepileProps {
    groupInformation: GroupInformation;
    clientScenario: string;
}

@observer
export default class GroupFacepile extends React.Component<GroupFacepileProps> {
    constructor(props: GroupFacepileProps) {
        super(props);
    }

    public render() {
        return (
            <div className={styles.groupFacepile}>
                {this.getMembersToDisplay(this.props.groupInformation).map(member => (
                    <GroupFacepilePersona
                        key={member.smtpAddress}
                        name={member.displayName}
                        emailAddress={member.smtpAddress}
                        clientScenario={this.props.clientScenario}
                    />
                ))}
            </div>
        );
    }

    private getMembersToDisplay(groupInformation: GroupInformation) {
        // We're always fetching 5 members even though we only want to show 4 on the Header.
        // The reason for that is that when getting back the members by relevance, we always get back
        // ourselves in the first position when we are a member of the group.
        // In the case that we have more than 4 members to show, we always want to remove ourselves and make sure that other members
        // show up in the header
        const MAX_FACES = MaxGroupMembersToReturn - 1;
        let userSmtp = getUserSmtp();
        userSmtp = userSmtp && userSmtp.toLowerCase();

        let membersArray = groupInformation.members.membersArray;

        // Check if there's more than 4 members in the members array.
        // If so, we want to make sure we (the user) are not included in the list
        if (membersArray.length > MAX_FACES) {
            membersArray = membersArray.filter(member => {
                const memberEmail =
                    member.Persona.EmailAddress.EmailAddress &&
                    member.Persona.EmailAddress.EmailAddress.toLowerCase();
                return memberEmail != userSmtp;
            });
        }

        return membersArray.slice(0, MAX_FACES).map(member => ({
            smtpAddress: member.Persona.EmailAddress.EmailAddress,
            displayName: member.Persona.DisplayName,
        }));
    }
}
